import Arrowsvg, { SavedAdressSvg } from "@/Pages/Dashboard/Seller/svg/Svg";
import { useDashboardStore } from "@/Store/DashboardStore";
import { useUserStore } from "@/Store/UserInfoStore";
import { InstaPayLogo } from "@/Svg/Svg";
import { Divider } from "@mui/material";
import {
  Archive,
  ArrowLeft,
  History,
  LayoutDashboard,
  Package,
  Settings,
  Store
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const AppSidebar = ({ setCollapsed, collapsed, open, setOpen }) => {
  const { t } = useTranslation();
  const { StoreInfo } = useDashboardStore();
  const user = useUserStore((state) => state.user);
  const navigate = useNavigate();
  const existStore = !!StoreInfo?._id;
  const location = useLocation();
  // console.log(user);
  const items = [
    {
      title: "Addresses",
      url: "/dashboard/buyer/manage-addresses",
      icon: SavedAdressSvg,
    },
    {
      title: "Order History",
      url: "/dashboard/buyer/order-history",
      icon: History,
    },
  ];
  const prohibitSellerJoinPaths = [
    "/dashboard/seller/join",
    "/dashboard/seller/settings",
    "/dashboard/seller",
  ];

  return (
    <div
      className={`
     bg-white  h-[100%] shadow-[15.146px_4.328px_242.341px_0_rgba(0, 0, 0, 0.07)] px-4 m-4 mt-[5%]  py-6 sticky left-0 transition-all  duration-300 ${collapsed ? "w-20" : "w-[250px]"
        }`}
    >
      <div className="mb-6 px- flex items-center justify-between w-full">
        <div
          className="flex items-center "
          onClick={() => setCollapsed(!collapsed)}
        >
          <InstaPayLogo width="25" height="30" />
          {!collapsed && (
            <span className="font-bold text-lg text-[#000]">InataPay</span>
          )}
        </div>
        {!collapsed && (
          <div
            className="flex items-center gap-2 cursor-pointer  p-1 
            rounded-[4px]  bg-[rgba(51,_51,_51,_0.04)]"
            onClick={() => setCollapsed(!collapsed)}
          >
            <Arrowsvg colors="black" width="25" height="25" />
          </div>
        )}
      </div>
      {!collapsed && existStore && (
        <div className="px-4 text-sm font-medium text-[#1454FB] mb-4">
          {t("Seller Links")}
        </div>
      )}
 <Divider />
      <div className="mt-6">
        {existStore && (
          <>
            <NavLink
              to="/dashboard/seller"
              end
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-[4px] text-[#777] text-[12px] font-[600] cursor-pointer
     hover:bg-[#E7EEFF] transition-colors
     ${isActive ? "bg-[#E7EEFF] text-[#1454FB]" : ""}`
              }
            >
              <Store size={18} />
              {!collapsed && <span>{t("Store Dashboard")}</span>}
            </NavLink>
            <NavLink
              to="/dashboard/seller/orders"
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-[4px] text-[#777] text-[12px] font-[600] cursor-pointer
     hover:bg-[#E7EEFF] transition-colors
     ${isActive ? "bg-[#E7EEFF] text-[#1454FB]" : ""}`
              }
            >
              <Package size={18} />
              {!collapsed && <span>{t("My Order")}</span>}
            </NavLink>
            <NavLink
              to="/dashboard/seller/products"
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-[4px] text-[#777] text-[12px] font-[600] cursor-pointer
     hover:bg-[#E7EEFF] transition-colors 
     ${isActive ? "bg-[#E7EEFF] text-[#1454FB]" : ""}`
              }
            >
              <Archive size={18} />
              {!collapsed && <span>{t("Product Dashboard")}</span>}
            </NavLink>
            <NavLink
              to={
                existStore
                  ? "/dashboard/seller/settings"
                  : "/dashboard/seller/join"
              }
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-[4px] text-[#777]
     text-[12px] font-[600] cursor-pointer
     hover:bg-[#E7EEFF]
     ${isActive ? "bg-[#E7EEFF] text-[#1454FB]" : ""}`
              }
            >
              <Settings size={18} />
              {!collapsed && <span>{t("Store Settings")}</span>}
            </NavLink>
          </>
        )}
        {!existStore && !prohibitSellerJoinPaths.includes(location.pathname) && (
          <div>
            {
              user?.source === "ecom" ? (
                <button
                  onClick={() => setOpen(true)}
                  className="p-2 border rounded mb-2 w-full cursor-pointer"
                >
                  {t("Join as Seller")}
                </button>
              ) : (
                <button
                  onClick={() => navigate("/dashboard/seller/settings")}
                  className="p-2 border rounded mb-2 w-full cursor-pointer"
                >
                  {t("Create Store")}
                </button>
              )}
          </div>
        )}

        {!collapsed && (
          <div className="px-4 mt-4 text-sm font-medium text-[#1454FB] mb-4">
            {t("Buyer Links")}
          </div>
        )}
        {items.map((item) => (
          <NavLink
            key={item.title}
            to={item.url}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-3 rounded-[4px] text-[12px] font-semibold
              ${isActive ? "bg-blue-100 text-blue-600" : "text-gray-500 hover:bg-blue-50"}`
            }
          >
            <item.icon className="h-4 w-4" />
            {!collapsed && <span>{t(item.title)}</span>}
          </NavLink>
        ))}
      </div>

      <NavLink
        to="/"
        className={({ isActive }) =>
          ` absolute bottom-10 flex items-center gap-2 px-14 py-2 rounded-[4px] text-[#777] text-[12px] font-[600] cursor-pointer
     hover:bg-[#E7EEFF]
     ${isActive ? "bg-[#E7EEFF] text-[#1454FB]" : ""}`
        }
      >
        <ArrowLeft size={18} />
        {!collapsed && <span>{t("Back TO Home")}</span>}
      </NavLink>
    </div>
  );
};

export default AppSidebar;
